import React from "react";
import DualListBox from "react-dual-listbox";
import PropTypes from "prop-types";
import {Alert} from "react-bootstrap";
import 'react-dual-listbox/lib/react-dual-listbox.css';
import {HiChevronDoubleLeft, HiChevronDoubleRight, HiChevronLeft, HiChevronRight} from "react-icons/hi";
import {useListaUprawnienOperatorow} from "../../../api/domain/raporty/queries/useListaUprawnienOperatorow.jsx";
import styled from 'styled-components'

export const Wrapper = styled.div`
    * > * {
        border-radius: 0;
        outline: none;
        color: #212529;
    }

    option[data-real-value="0"] {
        color: #777;
    }

    option {
        padding-bottom: 4px
    }

    *:disabled {
        cursor: not-allowed !important;
    }


    input:focus, input:active, select:focus, select:active, button:focus, button:active, select:focus, select:active, .rdl-control-container:focus {

        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        border: 1px solid rgb(134, 163, 208);
        box-shadow: rgba(13, 71, 161, 0.25) 0 0 0 4px;
        outline: 0 none;
    }

    button {
        align-items: center;
        text-align: center;
        outline: none;

    }

    option {
        white-space: pre-wrap;
        margin: 0 3px 15px;
        background-color: #f4f4f4;
        padding: 5px 9px;
        border-radius: 3px;
        font-size: .925rem;
        font-weight: bold;

    }
    ::-webkit-scrollbar {
        width: 15px;
    }
    ::-webkit-scrollbar-track {
        background-color: #f1f1f1;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #888;
        border-radius: 5px;
    }
    ::-webkit-scrollbar-thumb:hover {
        background-color: #555;
    }

    .rdl-control-container, .rdl-selected, .rdl-control {
        min-height: 40vh;
        //max-height: 16vw;
        background-color: #fff;
    }

    .rdl-selected::before {
        content: 'Wybrane:';
    }

    .rdl-available::before {
        content: 'Dostępne:';
    }
    .rdl-filter {
            background-color: #fff !important;
    }

    .rdl-available::before, .rdl-selected::before {
        min-width: 13%;
        padding: 4px 8px 2px;
        margin: 0 0 7px;
        text-align: center;
        font-weight: bold;
        font-size: .875rem;
        background-color: #f4f4f4;
    }


    .react-dual-listbox.rdl-has-filter {
        display: ${props => props.horizontal ? 'flex' : null};
        flex-direction: ${props => props.horizontal ? 'column' : null};

    }

    .rdl-actions, .rdl-actions-left, .rdl-actions-right {
        display: ${props => props.horizontal ? 'flex' : null};
        flex-direction: ${props => props.horizontal ? 'row' : null};
        align-items: ${props => props.horizontal ? 'flex-start' : null};
        padding: ${props => props.horizontal ? ' 4px 0' : null};

    }

    .rdl-actions {
        width: ${props => props.horizontal ? '100%' : null};

        justify-content: ${props => props.horizontal ? 'space-between' : null};
        height: ${props => props.horizontal ? '45px' : null};
    }

    .rdl-control-container > select > option {
        margin-bottom: 15px;
        max-width: ${props => props.horizontal ? '100%' : null};
        white-space: ${props => props.horizontal ? 'pre-wrap' : null};
        //word-wrap: break-word !important;
        //text-overflow: ellipsis; //use this if you want to shorten
    }

    #rdl-0uiVW6Lp_gwPkeYz4zRDT-option-39 {
        color: #471c1c;
        word-wrap: break-word !important;
    }

    .react-dual-listbox {
        min-height: 100%;
    }
`


export const DualBoxData = (props) => {

    const uprawnienia = useListaUprawnienOperatorow()

    const icons = {
        moveLeft: <HiChevronLeft size={25} title={'usuń zaznaczone'}/>,
        moveAllLeft: [
            <HiChevronDoubleLeft size={25} title={'usuń wszystkie'}/>,
        ],
        moveRight: <HiChevronRight size={25} title={'dodaj zaznaczone'}/>,
        moveAllRight: [
            <HiChevronDoubleRight size={25} title={'dodaj wszystkie'}/>,
        ],
        moveDown: <span title={'zmień'} className="fa fa-chevron-down"/>,
        moveUp: <span title={'zmień'} className="fa fa-chevron-up"/>,
        moveTop: <span title={'zmień'} className="fa fa-double-angle-up"/>,
        moveBottom: <span title={'zmień'} className="fa fa-double-angle-down"/>,
    }

    return (
        <Wrapper horizontal={props.horizontal}>
            <>
                <div className={"mt-3"}>
                    <DualListBox
                        showOrderButtons={true}
                        disabled={!uprawnienia}
                        icons={icons}
                        filterPlaceholder={props.loading ? "Pobieramy dane ..." : "Wyszukaj..."}
                        canFilter
                        options={uprawnienia?.data
                            ? uprawnienia.data.map(p => ({value: p.id, label: p.opis ? `${p.id} (${p.opis})` : p.id}))
                            : [{value: 0, label: "Brak danych słownika"}]
                        }
                        selected={props.value}
                        onChange={props.onChange}
                    />
                </div>
                {props.bottomActions && props.bottomActions()}
                {props.errorText && (
                    <Alert className={"p-1 w-100"} variant={"danger"}>
                        <div className={"ms-1"}> {props.errorText}</div>
                    </Alert>
                )}
            </>
        </Wrapper>
    );
};

DualBoxData.defaultProps = {
    label: "",
};

DualBoxData.propTypes = {
    queryId: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    dataEndpoint: PropTypes.string.isRequired,
    horizontal: PropTypes.bool,
    bottomActions: PropTypes.func,
    label: PropTypes.string,
    loading: PropTypes.bool,
    filter: PropTypes.any, // wartość, po której filtrujemy na zasadzie - splitter.key, splitter.value
    errorText: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    showId: PropTypes.bool,

};
